var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"section-2__content"},[_c('BoardListView',{attrs:{"boardType":"TaskCommunity","qnaTotalCount":_vm.qnaTotalCount,"qnaList":_vm.qnaList},on:{"doSearch":_vm.getCommunity,"onlyMyQnA":_vm.getCommunity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }